document.addEventListener('DOMContentLoaded', function () {
  // Select all accordion headers with a caret icon
  const accordionHeaders = document.querySelectorAll('.accordion-header');

  accordionHeaders.forEach(header => {
    const caret = header.querySelector('.icon-caret'); // Get the caret icon inside the header
    const accordionItem = header.closest('.accordion-item'); // Get the parent accordion-item
    const mainParent = header.closest('.main-parent'); // Ensure main-parent stays open

    // Only proceed if there is a caret icon
    if (caret) {
      // Add click event listener to the caret icon
      caret.addEventListener('click', function (e) {
        e.stopPropagation(); // Prevent the click from propagating to the parent (accordion-header)

        // Close all other dropdowns except the current one
        const allAccordions = document.querySelectorAll('.accordion-item');
        allAccordions.forEach(item => {
          if (item !== accordionItem && !item.classList.contains('main-parent')) {
            item.removeAttribute('open'); // Close other accordion items
          }
        });

        // Toggle the open state of the clicked accordion item
        if (accordionItem.hasAttribute('open')) {
          accordionItem.removeAttribute('open'); // Close the clicked one
        } else {
          accordionItem.setAttribute('open', ''); // Open the clicked one
        }

        // Optionally, toggle the caret icon rotation when open/close
        caret.classList.toggle('active');
      });
    }
  });
});
